/**
 * we can't use scroll-behavior: smooth; in css because of the compatibility with gsap, so we need to use js
 */
document.querySelectorAll('.wp-site-blocks a[href^="#"]:not(a[href="#"])').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent the default anchor link behavior

        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            const offset = 130; // Offset in pixels
            const elementPosition = target.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: elementPosition - offset,
                behavior: 'smooth'
            });
        }
    });
});